import { querySuiteRuns } from '@/features/executions/data';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult, SuiteRunDto } from '@flowqa/shared';

export const fetchSuiteRunsGrid = async (
  input: GridQueryInput,
  projectId?: string | null,
  organisationId?: string | null,
  includeSummary = false,
): Promise<QueryResult<SuiteRunDto>> => {
  return await querySuiteRuns(projectId ?? undefined, organisationId ?? undefined, {
    ...input,
    include: {
      suite: true,
    },
    includeSummary,
  });
};
